<script lang="ts" setup>
import { computed } from "vue";
import ValorumProLogo from "@/assets/images/brand/valorum-pro-logo.png";

const hostname = window.location.hostname.toLowerCase();
const isValorumPro = computed(() => (
  hostname === "copay.valorumpro.com" ||
  hostname === "demo.copay.valorumpro.com" ||
  hostname === "localhost" ||
  hostname === "127.0.0.1"
));
</script>

<template>
  <v-card class="text-center auth-card caravel-auth-brand-card">
    <div v-if="isValorumPro" class="caravel-auth-brand-card__content caravel-auth-brand-card__content--valorum">
      <img
        :src="ValorumProLogo"
        alt="ValorumPRO Patient Resource Optimization"
        class="caravel-auth-brand-card__logo"
      >
      <h1>Patient Access Portal</h1>
      <p class="caravel-auth-brand-card__welcome">
        Sign in to access enrollment, benefits verification, and program management tools.
      </p>
    </div>

    <div v-else class="caravel-auth-brand-card__content">
      <h1>Patient Access Operations</h1>
      <p class="caravel-auth-brand-card__eyebrow">Patient Access Portal</p>
      <p class="caravel-auth-brand-card__support">Operated by Atna • Powered by Caravel</p>
    </div>
  </v-card>
</template>

<style scoped>
.caravel-auth-brand-card {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100%;
  padding: 48px 32px;
}

.caravel-auth-brand-card__content {
  max-width: 360px;
  margin: 0 auto;
}

.caravel-auth-brand-card__content--valorum {
  max-width: 390px;
}

.caravel-auth-brand-card__logo {
  display: block;
  width: min(90%, 297px);
  height: auto;
  margin: 0 auto 22px;
}

.caravel-auth-brand-card__content--valorum h1 {
  margin-bottom: 12px;
  color: #061a44;
  font-size: 1.35rem;
}

.caravel-auth-brand-card__welcome {
  max-width: 320px;
  margin: 0 auto;
  color: #526078;
  font-size: 0.95rem;
  line-height: 1.55;
}

.caravel-auth-brand-card__mark {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  margin-bottom: 24px;
  border-radius: 20px;
  background: rgba(0, 150, 160, 0.12);
  color: #007d86;
  font-weight: 800;
  letter-spacing: 0.08em;
}

.caravel-auth-brand-card h1 {
  margin: 0 0 18px;
  font-size: 1.75rem;
  line-height: 1.15;
}

.caravel-auth-brand-card__eyebrow {
  margin: 0 0 8px;
  font-size: 0.9rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.caravel-auth-brand-card__support {
  margin: 0;
  opacity: 0.75;
  font-size: 0.9rem;
}
</style>
